import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import logoBig from 'images/logo-big.svg';
import ContactUsLink from './ContactUsLink';
import { toggleTermsOfServicesModal } from 'store/modules/modals';
import SocialLinksFooter from 'components/SocialLinksFooter';

const Footer = ({ toggleTermsOfServicesModal }) => {
  return (
    <div className="footer">
      <div className="wrapper">
        <div className="footer__content">
          <Link to="/" className="logo">
            <img src={logoBig} alt="" />
          </Link>
          <SocialLinksFooter />
          <ul className="navmenu">
            <li className="navmenu__itm">
              <Link to="/privacy" className="navmenu__link">
                Privacy
              </Link>
            </li>
            <li className="navmenu__itm">
              <Link
                to="/"
                onClick={toggleTermsOfServicesModal}
                className="navmenu__link">
                Terms
              </Link>
            </li>
            {/*<li className="navmenu__itm">*/}
            {/*<Link to="/#pricing_plans_section" className="navmenu__link">*/}
            {/*Pricing*/}
            {/*</Link>*/}
            {/*</li>*/}
            <li className="navmenu__itm">
              <Link to="/faq" className="navmenu__link">
                FAQ
              </Link>
            </li>
            <li className="navmenu__itm">
              <ContactUsLink />
            </li>
          </ul>
        </div>
        <div className="copyright">
          © Copyright {new Date().getFullYear()} InstaLinks. All rights reserved.
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  toggleTermsOfServicesModal,
};

export default connect(
  null,
  mapDispatchToProps,
)(Footer);



// WEBPACK FOOTER //
// ./src/scenes/Footer/Footer.js